import {UserRepository} from '../repository/UserRepository';
import {DashboardUser} from '../models/user.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class GetUserByIdUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (userId: number): Promise<DashboardUser> {
    // Validate user ID
    if (!userId || userId < 1) {
      throw new AppError('معرف المستخدم صحيح مطلوب', ErrorType.VALIDATION);
    }

    try {
      // Get user by ID from repository
      const user = await this.userRepository.getUserById(userId);

      return user;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
